// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@mcmc/App/Store/Selectors/SettingsSelectors";
import LazyImage, { LazyImageProps } from "@mcmc/MobiusOverrides/LazyImage";
import { cloudinary } from "@mcmc/XDL/Utilities";
import React, { FC } from "react";
import { connect } from "react-redux";

interface OwnProps extends LazyImageProps {
    imageTransformations: string | undefined;
}

const mapStateToProps = (state: ApplicationState) => {
    const customSettings = getSettingsCollection(state).customSettings;
    return {
        cloudinaryBaseURL: customSettings.cloudinaryBaseURL,
        defaultProductFallbackImage: customSettings.defaultProductFallbackImage,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const CloudinaryImage: FC<Props> = ({
    src,
    imageTransformations,
    cloudinaryBaseURL,
    defaultProductFallbackImage,
    onError,
    ...otherProps
}) => {
    const [isError, setIsError] = React.useState(false);
    React.useEffect(() => {
        setIsError(false);
    }, [src]);
    const onErrorHandler = () => {
        setIsError(true);
    };

    let imagePath = isError ? defaultProductFallbackImage : src || defaultProductFallbackImage;
    if (imageTransformations) {
        imagePath = cloudinary(cloudinaryBaseURL, imagePath, imageTransformations) || imagePath;
    }

    return (
        <LazyImage
            src={imagePath}
            onError={() => {
                onErrorHandler();
                onError?.();
            }}
            {...otherProps}
        />
    );
};

export default connect(mapStateToProps)(CloudinaryImage);
